import { render, staticRenderFns } from "./nuevo_usuario.vue?vue&type=template&id=20612a92&"
import script from "./nuevo_usuario.vue?vue&type=script&lang=js&"
export * from "./nuevo_usuario.vue?vue&type=script&lang=js&"
import style0 from "./nuevo_usuario.vue?vue&type=style&index=0&id=20612a92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports